"use client";

// Small helper to re-establish the server session cookie from current Firebase user
import { clientAuth } from "@/lib/firebase/client";

let inflight: Promise<boolean> | null = null;

/**
 * Attempt to repair the server session by exchanging a fresh Firebase ID token
 * for an httpOnly session cookie at /api/session. Safe to call multiple times;
 * concurrent calls are coalesced.
 */
export function repairServerSession(): Promise<boolean> {
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const auth = clientAuth();
      const user = auth.currentUser;
      if (!user) return false;

      // Get fresh ID token. forceRefresh is set to 'true'
      const idTokenJWT = await user.getIdToken(true);

      /** Send the id token to server.
       * Server will set the session cookie if token is valid
       * should return ok status.
       */
      const res = await fetch("/api/session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ idToken: idTokenJWT }),
      });
      return res.ok;
    } catch {
      return false;
    } finally {
      // allow subsequent attempts
      inflight = null;
    }
  })();
  return inflight;
}
